module.exports = __webpack_public_path__ + "42ced002f00e7bb9bd9d7e0ecad43c7d.svg";